<button class="ep-btn ep-btn-secondary webshop-button" *ngIf="!!authService.permissions.SENSOR_WEBSHOP" (click)="openWebShop()">
  <app-svg-icon src="./assets/icons/ico_cart_2" class="app-svg"></app-svg-icon>
  <label class="text">{{ 'module.sensorData.common.webshopText' | translate }}</label>
</button>
